import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GlobalService } from 'src/app/global.service';
import { LoginService } from 'src/app/Common/Services/login.service';
import { ToastrService } from 'ngx-toastr';
import { HttpHeaders } from '@angular/common/http';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { AdminService } from 'src/app/Common/Services/admin.service';

export interface language{
  value: string;
  viewValue: string;
}



@Component({
  selector: 'app-language-setup',
  templateUrl: './language-setup.component.html',
  styleUrls: ['./language-setup.component.css']
})
export class LanguageSetupComponent implements OnInit {
  langform:FormGroup;
  unselectlist:any[]=[];
  languageList :any[]=[];
  value:any;
  value1 :any;
  val :any;
  flag:boolean=false;
  languages:language[]=[
   {value: '01', viewValue: 'English'},
    {value: '02', viewValue: 'French'},
    {value: '03', viewValue: 'Creole'}
  ];

  

  constructor(public global: GlobalService,private _formbuilder: FormBuilder,public loginservice:LoginService,private toastr: ToastrService,public adminservice:AdminService) {

    this.langform=this._formbuilder.group({
      language:['',[Validators.required]]
    });
   }

  ngOnInit() {
    
    var ss=parseInt("01");
    var value ="1";
    
    //this.langform.get('language').setValue('English');
    //this.langform.get('language').setValue('01','02');

    this.loginservice.checkedvalues(value).subscribe((data:any)=>{
      if(data.responseBody.Detail != null){
      
    var check;
for(let i=0;i<data.responseBody.Detail.length;i++){
  check="check"+(parseInt(data.responseBody.Detail[i].code)-1);
  (<HTMLInputElement>document.getElementById(check)).checked = true;
  (<HTMLInputElement>document.getElementById("check0")).checked = true;
  (<HTMLInputElement>document.getElementById("check0")).disabled = true;
}
  
      
    }
  });
}


  onCheckChange($event){
 
    this.flag=true;
    if($event.target.checked ==true){
      this.val= $event.target.defaultValue;
      this.languageList.push(this.val);  
      this.value = "1";
   console.log("Language List", this.languageList);
    }else{
     const items =this.languageList;
    
      this.val= $event.target.defaultValue;
      this.unselectlist.push(this.val);
       this.value1 = "0";
       const valuesToRemove = this.unselectlist;
       let filteredItems = items.filter(item => !valuesToRemove.includes(item));
       this.languageList=[];
      
       for(let i=0;i<filteredItems.length;i++){
        this.languageList.push(filteredItems[i]);
       }
       //this.languageList.push(filteredItems);
       console.log("Language List", this.unselectlist);

    }
  }

 
  submit(){
    
    //if( this.flag!=true){
    this.languageList=[];
   if((<HTMLInputElement>document.getElementById("check0")).value!=undefined &&  (<HTMLInputElement>document.getElementById("check0")).checked==true){
    this.languageList.push((<HTMLInputElement>document.getElementById("check0")).value);
   }
   if((<HTMLInputElement>document.getElementById("check1")).value!=undefined &&  (<HTMLInputElement>document.getElementById("check1")).checked==true){
    this.languageList.push((<HTMLInputElement>document.getElementById("check1")).value);
   }
   if((<HTMLInputElement>document.getElementById("check1")).value!=undefined &&  (<HTMLInputElement>document.getElementById("check2")).checked==true){
    this.languageList.push((<HTMLInputElement>document.getElementById("check2")).value);
   }
  //}
   // if(this.value != undefined){
      var langlist = this.languageList;
      var value =  "1";
      let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    this.loginservice.languageSetup(langlist,value).subscribe((res: any)=>{
      console.log(res);
      
      if(res.responseBody.validationMsg){
        this.toastr.success(res.responseBody.validationMsg, undefined, {
          positionClass: 'toast-bottom-right',
          timeOut: 6000
     });
      }
    })
  // }
    // else{
    //   
    //   var unselectllist = this.unselectlist;
    //   var value1 =  this.value1;
    //   let headers = new HttpHeaders();
    //   headers = headers.set('Content-Type', 'application/json');
    //   this.loginservice.langauagechange(unselectllist,value1).subscribe((res: any)=>{
    //     console.log(res);
    //     
    //     if(res.responseBody.validationMsg){
    //       this.toastr.success(res.responseBody.validationMsg, undefined, {
    //         positionClass: 'toast-bottom-right',
    //         timeOut: 6000
    //    });
    //     }
    //   })
    // }
  
  }

  

}
